// View: Account
function view_account() {
  var $ = jQuery;

  charleys_show_loading();

  $contentContainer
    .load(templateRoot + "wf-ordering-account.html", function () {
      $("[data-account-return]").addClass("hide");
      $.when(
        olo_get_user_details()
      ).done(function (user_details_json) {
        var user_details = JSON.parse(user_details_json);

        $("[data-account-name]").text(user_details.firstname + " " + user_details.lastname);
        $("[data-account-email]").text(user_details.emailaddress);

        charleys_hide_loading();

        $("[data-account-home]").removeClass("hide");
      });
    })
    .hide()
    .fadeIn(transitionDuration);
}

// View: Account - Management
function view_account_manage() {
  var $ = jQuery;

  charleys_show_loading();

  $contentContainer
    .load(templateRoot + "wf-ordering-account.html", function () {
      $("[data-account-return]").removeClass("hide");

      $("input#account-contactdetails").inputmask({
        mask: phonesMasks,
        greedy: false,
        definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
      });

      $.when(
        olo_get_user_details(),
        olo_get_user_contact_details(),
        olo_get_user_communication_details(),
        olo_get_billing_accounts()
      ).done(function (
        user_details_json,
        user_contact_json,
        user_communication_json,
        user_billing_accounts_json
      ) {
        var user_details = JSON.parse(user_details_json[0]);
        var user_contact = JSON.parse(user_contact_json[0]);
        var user_communication = JSON.parse(user_communication_json[0]);
        var user_billing_accounts = JSON.parse(user_billing_accounts_json[0]);

        console.log(user_details, user_contact, user_communication);

        new Foundation.Accordion($("#manage-account-menu"), {});

        $("[data-account-name]").text(
          user_details.firstname + " " + user_details.lastname
        );
        $("[data-account-email]").text(user_details.emailaddress);

        $("#account-firstname").val(user_details.firstname);
        $("#account-lastname").val(user_details.lastname);
        $("#account-emailaddress").val(user_details.emailaddress);
        $("#account-contactdetails").val(user_contact.contactdetails);

        $("#account-optin").prop("checked", user_communication.optin == "true");

        $("#account-marketingsms").val(user_communication.marketingsms);
        $("#account-upsell").val(user_communication.upsell);
        $("#account-emailreceipts").val(user_communication.emailreceipts);
        $("#account-followups").val(user_communication.followups);

        $("[data-account-manage]").removeClass("hide");

        // Remove Reveals that may remain
        $(".delete-account").each(function () {
          if (typeof $(this).attr("aria-hidden") !== "undefined") {
            $(this).parent().remove();
          }
        });

        new Foundation.Abide($("#update_user_details"), {});
        new Foundation.Abide($("#change_password"), {});
        new Foundation.Reveal($("#delete-account"), {});

        // Clear Displayed Payments
        $("[data-billing-account-saved-template]:not(.hide)").remove();
        // Clear Saved Payments
        $("[data-billing-account-saved-template]:not(.hide)").remove();
        // Display saved billing accounts
        $.each(user_billing_accounts.billingaccounts, function (key, account) {
          var $savedSchemesContainer = $("[data-billing-accounts-saved]");
          var $savedScheme = $(
            "[data-billing-account-saved-template].hide"
          ).clone();

          $savedScheme.find("[data-make-default]").off("click");
          $savedScheme.find("[data-delete]").off("click");

          var cardTypes = ["Visa", "MasterCard", "Discover", "Amex"];

          if (cardTypes.includes(account.cardtype)) {
            $savedScheme
              .find(".fa-credit-card")
              .addClass("fa-cc-" + account.cardtype.toLowerCase());
            $savedScheme.find(".fa-credit-card").addClass("fa-brands");
            $savedScheme.find(".fa-credit-card").removeClass("fa-regular");
            $savedScheme.find(".fa-credit-card").removeClass("fa-credit-card");
          }

          // Set scheme element data params
          var paymentlabel = account.description;
          if (account.balance !== null && "balance" in account.balance) {
            paymentlabel +=
              "<br>Balance: $ " + formatMoney(account.balance.balance);
          }
          $savedScheme.find("[data-payment-label]").html(paymentlabel);
          $savedScheme.attr("id", "billing-account-" + account.accountidstring);
          $savedScheme.attr("data-billing-account-id", account.accountidstring);
          $savedScheme.attr("data-default", account.isdefault);
          // Set action button data params
          $savedScheme
            .find("[data-delete]")
            .attr("data-billing-account-id", account.accountidstring);
          $savedScheme
            .find("[data-make-default]")
            .attr("data-billing-account-id", account.accountidstring);

          if (account.isdefault || account.accounttype !== "creditcard") {
            $savedScheme.find("[data-make-default]").remove();
            if (account.accounttype !== "creditcard") {
              $savedScheme.find(".default-payment").remove();
            }
          } else {
            $savedScheme.find(".default-payment").remove();
            // Make Method Default
            $savedScheme.find("[data-make-default]").click(function () {
              charleys_show_loading();
              $.when(
                olo_default_billing_account(
                  $(this).attr("data-billing-account-id")
                )
              ).done(function (default_billing_json) {
                console.log(default_billing_json);
                change_view("account-manage");
              });
            });
          }
          // Delete method
          $savedScheme.find("[data-delete]").click(function () {
            charleys_show_loading();
            var billingAccountId = $(this).attr("data-billing-account-id");
            $.when(olo_delete_billing_account(billingAccountId)).done(function (
              deleted_billing_json
            ) {
              console.log(deleted_billing_json);
              var result = "";
              if (deleted_billing_json) {
                result = JSON.parse(deleted_billing_json);
              }
              // $('[data-open="credit-card-reveal"]').removeClass('hide');
              change_view("account-manage");
            });
          });
          $savedScheme.removeClass("hide");
          $savedSchemesContainer.append($savedScheme);
        });

        charleys_hide_loading();

        // submit account Update
        $("#update_user_details").submit(function (e) {
          e.preventDefault();
        });
        $("#update_user_details").bind("formvalid.zf.abide", function () {
          charleys_show_loading();
          $("#update_user_details").find(".alert").hide();
          //olo_update_user_profile
          $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
              action: "olo_update_user_profile",
              authtoken: localStorage.getItem("charleys_auth_token"),
              accesstoken: localStorage.getItem("charleys_access_token"),

              firstname: $("#account-firstname").val(),
              lastname: $("#account-lastname").val(),
              emailaddress: $("#account-emailaddress").val(),
              contactdetails: $("#account-contactdetails")
                .val()
                .replace(/\D/g, ""),

              marketingsms: $("#account-marketingsms").val() === "true",
              optin: $("#account-optin").prop("checked"),
              upsell: $("#account-upsell").val() === "true",
              emailreceipts: $("#account-emailreceipts").val() === "true",
              followups: $("#account-followups").val() === "true",
            },
            success: function (response) {
              var results = JSON.parse(response);
              console.log(results);

              if ("errors" in results[0]) {
                var errorMessage = "";
                $.each(results[0].errors, function (key, message) {
                  errorMessage += " " + message;
                  $("#update_user_details").foundation(
                    "addErrorClasses",
                    $('[data-punchh-label="' + key + '"]')
                  );
                });
                $("#update_user_details")
                  .find(".alert [data-error-message]")
                  .text(errorMessage);
                $("#update_user_details").find(".alert").show();
                charleys_hide_loading();
              } else {
                change_view("account-manage");
              }
            },
            complete: function () {},
          });
        });

        // Submit Password Change
        $("#change_password").submit(function (e) {
          e.preventDefault();
        });
        $("#change_password").bind("formvalid.zf.abide", function () {
          charleys_show_loading();
          $("#change_password").find(".alert").hide();
          $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
              action: "olo_update_password",
              accesstoken: localStorage.getItem("charleys_access_token"),
              current_password: $("#account_current_password").val(),
              password: $("#account_password").val(),
              password_confirmation: $("#account_password_confirmation").val(),
            },
            success: function (response) {
              var results = JSON.parse(response);
              console.log(results);

              if ("errors" in results || "error" in results || results.length) {
                // errors found
                var errorMessage = "";
                if("errors" in results) {
                  $.each(results.errors, function (key, message) {
                    errorMessage += " " + message;
                    $("#change_password").foundation(
                      "addErrorClasses",
                      $('[data-punchh-label="' + key + '"]')
                    );
                  });
                } else if("error" in results) {
                  errorMessage += " " + results.error;
                } else {
                  $.each(results, function (key, message) {
                    errorMessage += " " + message;
                  });
                }



                $("#change_password")
                  .find(".alert [data-error-message]")
                  .text(errorMessage);
                $("#change_password").find(".alert").show();

                charleys_hide_loading();

              } else {
                // success
                change_view("account-manage");
              }

            },
            complete: function () {},
          });
        });

        $("#delete-account [data-delete-account]").click(function () {
          charleys_show_loading();

          $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
              action: "olo_delete_user",
              authtoken: localStorage.getItem("charleys_auth_token"),
            },
            success: function (response) {
              $("#delete-account").foundation("close");
              charleys_hide_loading();
              change_view("signout");
            },
            complete: function () {},
          });
        });


        $('[data-account-edit-card]').each(function() {

          var $editButton = $(this).find('[data-account-edit-button]');
          var $cancelButton = $(this).find('[data-account-cancel-button]');
          var $formFields = $(this).find('[data-account-form-fields]');
          var $displayFields = $(this).find('[data-account-display-fields]')

          $('[data-account-form-fields] input').each(function() {
            var inputName = $(this).attr('name');
            if($('[data-account-display-fields] [data-name="'+inputName+'"]').length) {
              $('[data-account-display-fields] [data-name="'+inputName+'"]').text($(this).val());
            }
          });

          $editButton.click(function() {
            $cancelButton.removeClass('hide');
            $editButton.addClass('hide');

            $formFields.removeClass('hide');
            $displayFields.addClass('hide');
          });

          $cancelButton.click(function() {
            $editButton.removeClass('hide');
            $cancelButton.addClass('hide');

            $displayFields.removeClass('hide');
            $formFields.addClass('hide');
          });
        });

      });
    })
    .hide()
    .fadeIn(transitionDuration);
}

// View: Account - Recent Orders
function view_account_recent() {
  var $ = jQuery;

  charleys_show_loading();

  var totalLoadBeforeComplete = 2;

  $contentContainer.load(templateRoot + "wf-ordering-account.html", function () {
      $("[data-account-return]").removeClass("hide");

      // remove reveal modals
      $("#account-select-order-type, #home-select-order-type, #menu-select-order-type, #location-detail-order-type").each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $select_order_type_reveal = new Foundation.Reveal(
        $("#account-select-order-type"),
        {}
      );

      $("#account-select-order-type-button").off('click');
      $("#account-select-order-type-button").click(function () {
        if ($("[data-order-type-recent-id]").text() !== "") {
          startRecentOrder($("[data-order-type-recent-id]").text(), "account");
        }

        if ($("[data-order-type-fave-id]").text() !== "") {
          startFavoriteOrder($("[data-order-type-fave-id]").text(), "account");
        }
      });

      $('input[name="account-order-type"]').change(function () {
        clearLocationList();

        if (
          $('input[name="account-order-type"]:checked').val() !== "dispatch"
        ) {
          $("[data-search-deliver]").addClass("hide");
          $("#account-order-location-search").addClass("hide");
          $(".fa-location-dot").addClass("hide");
          $("#account-order-location-search-building").val("");
        } else {
          $("[data-search-deliver]").removeClass("hide");
          $("#account-order-location-search").removeClass("hide");
          $(".fa-location-dot").removeClass("hide");
        }

        if ($("#account-order-location-search").val()) {
          $("#account-order-location-search-form").submit();
        } else {
          populate_user_restaurants("account");
        }
      });

      // Hide/show schedule elements
      $('input[name="account-order-schedule"]').change(function () {
        if (
          $('input[name="account-order-schedule"]:checked').val() == "advance"
        ) {
          $("#account-schedule-time").removeClass("hide");
        } else {
          $("#account-schedule-time").addClass("hide");
        }
        // console.log($('input[name="order-schedule"]:checked').val());
      });

      var todaysDate = new Date();
      var tomorrowsDate = new Date().addDays(1);
      var scheduleDates = getDates(todaysDate, new Date().addDays(45));
      var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      for (var i = 0; i < scheduleDates.length; i++) {
        var dayValue =
          scheduleDates[i].getFullYear() +
          "-" +
          zeroPad(scheduleDates[i].getMonth() + 1, 2) +
          "-" +
          zeroPad(scheduleDates[i].getDate(), 2);
        var dayLabel =
          daysOfWeek[scheduleDates[i].getDay()] +
          " " +
          (scheduleDates[i].getMonth() + 1) +
          "/" +
          scheduleDates[i].getDate();

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
          dayLabel = "Today";
        }
        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
          dayLabel = "Tomorrow";
        }

        $("[data-account-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );
      }

      var timeSelection = createQuarterHourIntervals();

      console.log('time selection', timeSelection);

      for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-account-order-time-wanted-time]").append(
          '<option value="' +
            convert12to24Hour(timeSelection[ii]) +
            '">' +
            timeSelection[ii] +
            "</option>"
        );
      }

      $("select#account-time-wanted-day").change(function () {
        if (
          $(
            'select#account-time-wanted-day option[value="' +
              $(this).val() +
              '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          console.log(currentTime);
          $("select#account-time-wanted-time-slot option").each(function () {
            if ($(this).val() < currentTime) {
              $(this).addClass("hide");
            }
            $("select#account-time-wanted-time-slot").val(currentTime);
          });
        } else {
          $("select#account-time-wanted-time-slot option").each(function () {
            $(this).removeClass("hide");
          });
        }
      });

      $("select#account-time-wanted-day").trigger("change");

      // Autocomplete for location search
      if ($("#account-order-location-search").length) {
        const inputD = $("#account-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            olo_get_nearby_locations(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              "",
              "account"
            );
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            if (components.street_number && components.route) {
              $("#account-order-location-search-streetaddress").val(
                components.street_number + " " + components.route
              );
            }

            if('locality' in components) {
              $('#account-order-location-search-city').val(components.locality);
            } else if('administrative_area_level_2' in components){
              $('#account-order-location-search-city').val(components.administrative_area_level_2);
            }

            $("#account-order-location-search-zipcode").val(
              components.postal_code
            );

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        $("#account-order-location-search-form").submit(function (e) {
          e.preventDefault();

          console.log("search locations");

          $("#account-order-location-search").blur();

          var address = $("#account-order-location-search").val();
          var geocoder = new google.maps.Geocoder();

          if (address.length) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                console.log("GEOCODER STATUS ", status, results);
                if (status == google.maps.GeocoderStatus.OK) {
                  // console.log(results);

                  var components = {};
                  $.each(results[0].address_components, function (k, v1) {
                    $.each(v1.types, function (k2, v2) {
                      components[v2] = v1.long_name;
                    });
                  });

                  // console.log('address components', components);

                  if (components.street_number && components.route) {
                    $("#account-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );
                  }

                  if('locality' in components) {
                    $('#account-order-location-search-city').val(components.locality);
                  } else if('administrative_area_level_2' in components){
                    $('#account-order-location-search-city').val(components.administrative_area_level_2);
                  }

                  $("#account-order-location-search-zipcode").val(
                    components.postal_code
                  );

                  olo_get_nearby_locations(
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng(),
                    "",
                    "account"
                  );
                } else {
                  $("#account-order-location-search").val("");
                  charleys_hide_loading();
                }
              }
            );
          } else {
            charleys_hide_loading();
          }
        });
        // initMap();
      }

      // Remove reveal modal
      $(".account-add-favorite-order").each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $add_favorite_reveal = new Foundation.Reveal(
        $("#account-add-favorite-order"),
        {}
      );

      $.when(
        olo_get_user_details()
      ).done(function (user_details_json) {
        var user_details = JSON.parse(user_details_json);

        $("[data-account-name]").text(user_details.firstname + " " + user_details.lastname);
        $("[data-account-email]").text(user_details.emailaddress);

        if(isUserLoggedIn(true)) {
          $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
              action: "olo_get_recent_orders",
              authtoken: localStorage.getItem("charleys_auth_token"),
            },
            success: function (response) {
              var results = JSON.parse(response);

              if (results.orders !== undefined && results.orders.length > 0) {
                totalLoadBeforeComplete++;

                // cache menu for each restaurant
                var menu_results_cache = {};

                var order_locations = [];
                results.orders.forEach(function (order) {
                  // console.log(order_locations);
                  if (!order_locations.length || !order_locations.includes(order.vendorid)) {
                    order_locations.push(order.vendorid);
                  }
                });

                var menus_cached = 0;
                order_locations.forEach(function (order_location) {
                  $.ajax({
                    type: "POST",
                    url: ajax_url,
                    data: {
                      action: "get_olo_get_menu",
                      restaurant_id: order_location,
                    },
                    success: function (response) {
                      menu_results_cache[order_location] = JSON.parse(response);
                      menus_cached++;

                      if (menus_cached == order_locations.length) {
                        results.orders.forEach(function (order) {
                          if ((order.status == "Completed" || order.status == "In Progress" || order.status == "Scheduled") && order.products.length > 0) {
                            var $recent_order = $(
                              "[data-recent-order-template].hide"
                            ).clone();
                            $recent_order
                              .find("[data-recent-order-title]")
                              .text(order.name);
                            $recent_order
                              .find("[data-recent-order-id]")
                              .text(order.id);
                            $recent_order.find(".recent-order-id").text(order.id);
                            $recent_order
                              .find("[data-recent-order-vendor-id]")
                              .text(order.vendorid);
                            $recent_order
                              .find("[data-recent-order-vendor-name]")
                              .text(order.vendorname);

                            $recent_order.find('.recent-order-place-button').attr('data-recent-order-id', order.id);

                            var formatted_date =
                              order.timeplaced.substring(0, 4) +
                              "-" +
                              order.timeplaced.substring(4, 6) +
                              "-" +
                              order.timeplaced.substring(6, 8) +
                              order.timeplaced.substring(8);
                            $recent_order
                              .find("[data-recent-order-date]")
                              .text(formatted_date);
                            $recent_order
                              .find("[data-recent-order-status]")
                              .text(order.status);

                            var status_processed = order.status
                              .toLowerCase()
                              .replace(/ /g, "_");
                            $recent_order
                              .find("[data-status='" + status_processed + "']")
                              .removeClass("hide");

                            // get metadata about favorite menu items from associated restaurant menu
                            var menu_results = menu_results_cache[order.vendorid];

                            order.products.forEach(function (product) {
                              var matched = false;
                              var product_calories;
                              var product_price;
                              var product_image_filename;

                              menu_results.categories.every(function (category) {
                                category.products.every(function (cat_product) {
                                  if (product.name == cat_product.name) {
                                    product_calories = cat_product.basecalories;
                                    // product_price = cat_product.cost;
                                    product_image_path = menu_results.imagepath;
                                    product_image_filename =
                                      cat_product.imagefilename;
                                    matched = true;
                                  }
                                  return !matched;
                                });
                                return !matched;
                              });

                              var $recent_item = $recent_order
                                .find("[data-recent-order-item-template]")
                                .clone();

                              if (product_image_filename != null) {
                                $recent_item
                                  .find("img")
                                  .attr(
                                    "src",
                                    product_image_path + product_image_filename
                                  );
                              } else {
                                $recent_item
                                  .find("img")
                                  .attr(
                                    "src",
                                    "/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg"
                                  );
                              }

                              $recent_item
                                .find("[data-recent-order-item-name]")
                                .text(product.name);
                              if (product_calories != null) {
                                $recent_item
                                  .find("[data-recent-order-item-calories]")
                                  .text(product_calories + " Calories | ");
                              }
                              // $recent_item.find('[data-recent-order-item-price]').text(product_price);

                              var choiceArray = [];
                              product.choices.forEach(function (choice) {
                                choiceArray.push(choice.name);
                              });

                              $recent_item.removeClass("hide");
                              $recent_item
                                .find("[data-recent-order-item-choices]")
                                .text(choiceArray.join(", "));
                              $recent_item.removeAttr(
                                "data-recent-order-item-template"
                              );
                              $recent_order
                                .find(".recent-order-items")
                                .append($recent_item);
                            });

                            $recent_order.removeClass("hide");
                            $("[data-recent-orders-list]").append($recent_order);

                            $("[data-recent-orders-list]").removeClass("hide");

                            $(".recent-order-place-button").click(function () {
                              $("[data-order-type-fave-id]").text("");
                              $("[data-order-type-recent-id]").text($(this).attr('data-recent-order-id'));
                              // $("[data-order-type-recent-id]").text(
                              //   $(this)
                              //     .closest(".recent-order")
                              //     .find("[data-recent-order-id]")
                              //     .text()
                              // );
                              window.scrollTo(0, 0);
                              $("#account-select-order-type").foundation("open");
                            });
                          }
                        });

                        $(".account-favorite-button").click(function () {
                          $(".account-add-favorite-order-recent-order-id").text(
                            $(this).parent().find(".recent-order-id").text()
                          );
                          $("#account-add-favorite-order").foundation("open");
                        });

                        $(".account-confirm-add-favorite-button").click(
                          function () {
                            $.ajax({
                              type: "POST",
                              url: ajax_url,
                              data: {
                                action: "olo_create_basket_from_order",
                                authtoken: localStorage.getItem(
                                  "charleys_auth_token"
                                ),
                                orderid: $(
                                  ".account-add-favorite-order-recent-order-id"
                                ).text(),
                              },
                              success: function (response) {
                                result = JSON.parse(response);
                                console.log(response);
                                console.log(result);

                                $.ajax({
                                  type: "POST",
                                  url: ajax_url,
                                  data: {
                                    action: "olo_set_fave",
                                    authtoken: localStorage.getItem(
                                      "charleys_auth_token"
                                    ),
                                    basketid: result.id,
                                    description: $("[data-account-favorite-order-description]").val()
                                  },
                                  success: function (response) {
                                    fave_result = JSON.parse(response);

                                    if (fave_result.code == 200) {
                                      alert(fave_result.message);
                                      $("#account-add-favorite-order").foundation(
                                        "open"
                                      );
                                    } else if (fave_result.faves[0].id) {
                                      window.location.reload();
                                    }
                                  },
                                });
                              },
                            });
                          }
                        );

                        totalLoadBeforeComplete--;
                        if (totalLoadBeforeComplete == 0) {
                          $("[data-account-recent]").removeClass("hide");
                          charleys_hide_loading();
                        }
                      }
                    },
                    complete: function () {
                      totalLoadBeforeComplete--;
                      if (totalLoadBeforeComplete == 0) {
                        $("[data-account-recent]").removeClass("hide");
                        charleys_hide_loading();
                      }
                    },
                  });
                });
              } else {
                $("[data-recent-orders-loading]").addClass("hide");
                $("[data-recent-orders-not-found]").removeClass("hide");
                $("[data-account-recent]").removeClass("hide");
                charleys_hide_loading();
              }
            },
            complete: function () {
              totalLoadBeforeComplete--;
              if (totalLoadBeforeComplete == 0) {
                $("[data-account-recent]").removeClass("hide");
                charleys_hide_loading();
              }
            },
          });
        }

      });
    })
    .hide()
    .fadeIn(transitionDuration);
}

// View: Account - Favorite Orders
function view_account_favorite() {
  var $ = jQuery;

  charleys_show_loading();

  var totalLoadBeforeComplete = 2;

  $contentContainer
    .load(templateRoot + "wf-ordering-account.html", function () {
      $("[data-account-return]").removeClass("hide");

      // Remove reveal modal
      $(".account-delete-favorite-order").each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // remove reveal modals
      $("#account-select-order-type, #home-select-order-type, #menu-select-order-type, #location-detail-order-type").each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $account_delete_fave = new Foundation.Reveal(
        $("#account-delete-favorite-order"),
        {}
      );
      var $select_order_type_reveal = new Foundation.Reveal(
        $("#account-select-order-type"),
        {}
      );

      $("#account-select-order-type-button").off('click');
      $("#account-select-order-type-button").click(function () {
        if ($("[data-order-type-recent-id]").text() !== "") {
          startRecentOrder($("[data-order-type-recent-id]").text(), "account");
        }

        if ($("[data-order-type-fave-id]").text() !== "") {
          startFavoriteOrder($("[data-order-type-fave-id]").text(), "account");
        }
      });

      $('input[name="account-order-type"]').change(function () {
        clearLocationList();

        if (
          $('input[name="account-order-type"]:checked').val() !== "dispatch"
        ) {
          $("[data-search-deliver]").addClass("hide");
          $("#account-order-location-search").addClass("hide");
          $(".fa-location-dot").addClass("hide");
          $("#account-order-location-search-building").val("");
        } else {
          $("[data-search-deliver]").removeClass("hide");
          $("#account-order-location-search").removeClass("hide");
          $(".fa-location-dot").removeClass("hide");
        }

        if ($("#account-order-location-search").val()) {
          $("#account-order-location-search-form").submit();
        } else {
          populate_user_restaurants("account");
        }
      });

      // Hide/show schedule elements
      $('input[name="account-order-schedule"]').change(function () {
        if (
          $('input[name="account-order-schedule"]:checked').val() == "advance"
        ) {
          $("#account-schedule-time").removeClass("hide");
        } else {
          $("#account-schedule-time").addClass("hide");
        }
        // console.log($('input[name="order-schedule"]:checked').val());
      });

      var todaysDate = new Date();
      var tomorrowsDate = new Date().addDays(1);
      var scheduleDates = getDates(todaysDate, new Date().addDays(45));
      var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      for (var i = 0; i < scheduleDates.length; i++) {
        var dayValue =
          scheduleDates[i].getFullYear() +
          "-" +
          zeroPad(scheduleDates[i].getMonth() + 1, 2) +
          "-" +
          zeroPad(scheduleDates[i].getDate(), 2);
        var dayLabel =
          daysOfWeek[scheduleDates[i].getDay()] +
          " " +
          (scheduleDates[i].getMonth() + 1) +
          "/" +
          scheduleDates[i].getDate();

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
          dayLabel = "Today";
        }
        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
          dayLabel = "Tomorrow";
        }

        $("[data-account-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );
      }

      var timeSelection = createQuarterHourIntervals();

      console.log('time selection', timeSelection);

      for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-account-order-time-wanted-time]").append(
          '<option value="' +
            convert12to24Hour(timeSelection[ii]) +
            '">' +
            timeSelection[ii] +
            "</option>"
        );
      }

      $("select#account-time-wanted-day").change(function () {
        if (
          $(
            'select#account-time-wanted-day option[value="' +
              $(this).val() +
              '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          console.log(currentTime);
          $("select#account-time-wanted-time-slot option").each(function () {
            if ($(this).val() < currentTime) {
              $(this).addClass("hide");
            }
            $("select#account-time-wanted-time-slot").val(currentTime);
          });
        } else {
          $("select#account-time-wanted-time-slot option").each(function () {
            $(this).removeClass("hide");
          });
        }
      });

      $("select#account-time-wanted-day").trigger("change");

      // Autocomplete for location search
      if ($("#account-order-location-search").length) {
        const inputD = $("#account-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            olo_get_nearby_locations(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              "",
              "account"
            );
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            if (components.street_number && components.route) {
              $("#account-order-location-search-streetaddress").val(
                components.street_number + " " + components.route
              );
            }

            if('locality' in components) {
              $('#account-order-location-search-city').val(components.locality);
            } else if('administrative_area_level_2' in components){
              $('#account-order-location-search-city').val(components.administrative_area_level_2);
            }

            $("#account-order-location-search-zipcode").val(
              components.postal_code
            );

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        $("#account-order-location-search-form").submit(function (e) {
          e.preventDefault();

          console.log("search locations");

          $("#account-order-location-search").blur();

          var address = $("#account-order-location-search").val();
          var geocoder = new google.maps.Geocoder();

          if (address.length) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                console.log("GEOCODER STATUS ", status, results);
                if (status == google.maps.GeocoderStatus.OK) {
                  // console.log(results);

                  var components = {};
                  $.each(results[0].address_components, function (k, v1) {
                    $.each(v1.types, function (k2, v2) {
                      components[v2] = v1.long_name;
                    });
                  });

                  // console.log('address components', components);

                  if (components.street_number && components.route) {
                    $("#account-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );
                  }

                  if('locality' in components) {
                    $('#account-order-location-search-city').val(components.locality);
                  } else if('administrative_area_level_2' in components){
                    $('#account-order-location-search-city').val(components.administrative_area_level_2);
                  }

                  $("#account-order-location-search-zipcode").val(
                    components.postal_code
                  );

                  olo_get_nearby_locations(
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng(),
                    "",
                    "account"
                  );
                } else {
                  $("#account-order-location-search").val("");
                  charleys_hide_loading();
                }
              }
            );
          } else {
            charleys_hide_loading();
          }
        });
        // initMap();
      }

      $.when(olo_get_user_details()).done(function (user_details_json) {
        var user_details = JSON.parse(user_details_json);

        $("[data-account-name]").text(
          user_details.firstname + " " + user_details.lastname
        );
        $("[data-account-email]").text(user_details.emailaddress);

        // Retrieve favorite orders
        $.ajax({
          type: "POST",
          url: ajax_url,
          data: {
            action: "olo_get_faves",
            authtoken: localStorage.getItem("charleys_auth_token"),
          },
          success: function (response) {
            var results = JSON.parse(response);

            if (results.faves !== undefined && results.faves.length > 0) {
              totalLoadBeforeComplete++;

              // cache menu for each restaurant
              var menu_results_cache = {};

              var order_locations = [];
              results.faves.forEach(function (fave) {
                // if (!order_locations.contains(fave.vendorid)) {
                if (!order_locations.length || !order_locations.includes(fave.vendorid)) {
                  order_locations.push(fave.vendorid);
                }
              });

              var menus_cached = 0;
              order_locations.forEach(function (order_location) {
                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "get_olo_get_menu",
                    restaurant_id: order_location,
                  },
                  success: function (response) {
                    menu_results_cache[order_location] = JSON.parse(response);
                    menus_cached++;

                    if (menus_cached == order_locations.length) {
                      results.faves.forEach(function (fave) {
                        var $fave_order = $(
                          "[data-favorite-order-template].hide"
                        ).clone();
                        $fave_order
                          .find("[data-favorite-order-title]")
                          .text(fave.name);
                        $fave_order
                          .find("[data-favorite-order-id]")
                          .text(fave.id);
                        $fave_order.find(".favorite-order-id").text(fave.id);
                        $fave_order
                          .find("[data-favorite-order-vendor-id]")
                          .text(fave.vendorid);
                        $fave_order
                          .find("[data-favorite-order-vendor-name]")
                          .text(fave.vendorname);

                        $fave_order.find('.fave-order-place-button').attr('data-favorite-order-id', fave.id);

                        var menu_results = menu_results_cache[fave.vendorid];

                        fave.products.forEach(function (product) {
                          var matched = false;
                          var product_calories;
                          var product_price;
                          var product_image_filename;

                          console.log(product);

                          menu_results.categories.every(function (category) {
                            category.products.every(function (cat_product) {
                              if (product.productid == cat_product.id) {
                                product_calories = cat_product.basecalories;
                                // product_price = product.cost;
                                product_image_path = menu_results.imagepath;
                                product_image_filename =
                                  cat_product.imagefilename;
                                matched = true;
                              }
                              return !matched;
                            });
                            return !matched;
                          });

                          var $fave_item = $fave_order
                            .find("[data-favorite-order-item-template]")
                            .clone();

                          if (product_image_filename != null) {
                            $fave_item
                              .find("img")
                              .attr(
                                "src",
                                product_image_path + product_image_filename
                              );
                          } else {
                            $fave_item
                              .find("img")
                              .attr(
                                "src",
                                "/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg"
                              );
                          }

                          $fave_item
                            .find("[data-favorite-order-item-name]")
                            .text(product.name);
                          if (product_calories != null) {
                            $fave_item
                              .find("[data-favorite-order-item-calories]")
                              .text(product_calories + " Calories | ");
                          }
                          // $fave_item.find('[data-favorite-order-item-price]').text(product_price);

                          var choiceArray = [];
                          product.choices.forEach(function (choice) {
                            choiceArray.push(choice.name);
                          });

                          $fave_item.removeClass("hide");
                          $fave_item
                            .find("[data-favorite-order-item-choices]")
                            .text(choiceArray.join(", "));
                          $fave_item.removeAttr(
                            "data-favorite-order-item-template"
                          );
                          $fave_order
                            .find(".favorite-order-items")
                            .append($fave_item);
                        });

                        $fave_order.removeClass("hide");
                        $("[data-favorite-orders-list]").append($fave_order);

                        $(".account-favorite-button").click(function () {
                          $(".data-delete-fave-id").text(
                            $(this).parent().find(".favorite-order-id").text()
                          );
                          $(".account-delete-favorite-order").foundation(
                            "open"
                          );
                        });

                        $(".account-delete-favorite-button").click(function () {
                          $.ajax({
                            type: "POST",
                            url: ajax_url,
                            data: {
                              action: "olo_delete_fave",
                              authtoken: localStorage.getItem(
                                "charleys_auth_token"
                              ),
                              faveid: $("[data-delete-fave-id]").text(),
                            },
                            success: function (response) {
                              window.location.reload();
                            },
                          });
                        });

                        $("[data-favorite-orders-loading]").addClass("hide");
                        $("[data-favorite-orders-list]").removeClass("hide");

                        $(".fave-order-place-button").click(function () {
                          $("[data-order-type-recent-id]").text("");
                          $("[data-order-type-fave-id]").text($(this).attr('data-favorite-order-id'));
                          // $("[data-order-type-fave-id]").text(
                          //   $(this)
                          //     .closest(".favorite-order")
                          //     .find("[data-favorite-order-id]")
                          //     .text()
                          // );
                          window.scrollTo(0, 0);
                          $("#account-select-order-type").foundation("open");
                        });
                      });

                      totalLoadBeforeComplete--;
                      if (totalLoadBeforeComplete == 0) {
                        $("[data-account-favorite]").removeClass("hide");
                        charleys_hide_loading();
                      }
                    }
                  },
                  complete: function () {
                    totalLoadBeforeComplete--;
                    if (totalLoadBeforeComplete == 0) {
                      $("[data-account-favorite]").removeClass("hide");
                      charleys_hide_loading();
                    }
                  },
                });
              });
            } else {
              $("[data-favorite-orders-loading]").addClass("hide");
              $("[data-favorite-orders-not-found]").removeClass("hide");
              $("[data-account-favorite]").removeClass("hide");
              charleys_hide_loading();
            }
          },
          complete: function () {
            totalLoadBeforeComplete--;
            if (totalLoadBeforeComplete == 0) {
              $("[data-account-favorite]").removeClass("hide");
              charleys_hide_loading();
            }
          },
        });
      });
    })
    .hide()
    .fadeIn(transitionDuration);
}

// View: Account - View Rewards
function view_account_rewards() {
  var $ = jQuery;

  charleys_show_loading();

  $contentContainer
    .load(templateRoot + "wf-ordering-account.html", function () {
      $("[data-account-return]").removeClass("hide");

      $.when(olo_get_user_details()).done(function (user_details_json) {
        var user_details = JSON.parse(user_details_json);

        $("[data-account-name]").text(
          user_details.firstname + " " + user_details.lastname
        );
        $("[data-account-email]").text(user_details.emailaddress);

        new Foundation.Tabs($("#rewards-tabs"));

        $.when(
          // punchh_get_user_offers(),
          punchh_get_user_points()
        ).done(function (points_json) {
          console.log(points_json);

          var rewards = JSON.parse(points_json);
          var pointsToNext =
            100 - Number(rewards.account_balance.unbanked_points);

          $("[data-lifetime-points]").text(
            rewards.account_balance.lifetime_points + " points"
          );
          $("[data-redeemable-points]").text(
            "$" + rewards.account_balance.banked_currency
          );
          $("[data-next-reward]").text(pointsToNext + " points");

          $.each(rewards.notifications, function (key, value) {
            var $historyList = $("[data-rewards-history-list]");

            var $historyItem = $("[data-reward-item].hide").clone();

            var created_at = new Date(value.created_at);
            var displayDate =
              created_at.toLocaleDateString("en-US") +
              " at " +
              created_at.toLocaleTimeString("en-US");

            $historyItem.find("[data-history-date]").text(displayDate);
            $historyItem.find("[data-history-message]").text(value.message);

            $historyItem.removeClass("hide");
            $historyList.append($historyItem);
          });

          $("[data-account-rewards]").removeClass("hide");
          charleys_hide_loading();
        });
      });
    })
    .hide()
    .fadeIn(transitionDuration);
}
